import { axios } from "~/plugins/request"

export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  findReportState({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`academicPlanning/findReportState`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  list({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post(`academicPlanning/list`, params)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },



}
